<template lang="pug">
    section#conteudo
        .wrapper
            div.content(v-html="$props.conteudo")
        
</template>

<script>
export default {
    name: "section-conteudo",
    props: {
        conteudo: String
    }
}
</script>

<style lang="stylus" scoped src="./Conteudo.styl"></style>